import type { ClarityFileEditRequest } from './models/clarity-file-edit-request.model';

/**
 * Assemble the chat message an inline edit request populates into the input.
 *
 * The link label falls back `filePath` → `fileName` → `fileId`; the target is always the file id via
 * the `file://<uuid>` convention, so a message stays resolvable after a rename.
 *
 * Ported from Clarity `apps/web/src/shared/utils/buildFileEditRequestMessage.ts`.
 */
export function buildFileEditRequestMessage(request: ClarityFileEditRequest): string {
	const label = request.filePath || request.fileName || request.fileId;

	// Every line carries the `> ` marker. A single leading marker leaves lines 2+ outside the
	// blockquote, so a multi-line selection renders as body text — and reads to the agent as
	// instructions rather than as the quoted material it is asked to edit.
	const quoted = `"${request.selectedText}"`
		.split('\n')
		.map(line => `> ${line}`)
		.join('\n');

	return `Edit **[${label}](file://${request.fileId})**:\n\n${quoted}\n\n${request.editRequest}`;
}
